import Marionette from 'backbone.marionette';
import Navigator from 'app';
import billsHomeLayoutTmpl from '../templates/bills_home_layout.tpl';
export default Marionette.LayoutView.extend({
  template: billsHomeLayoutTmpl,
  regions: {
    watchedBillsCategoryRegion: "#watched-bills-category-region"
  },
  events: {
    'submit #bill-text-search': 'searchBillText',
    'submit #bill-search': 'billByNumber'
  },
  searchBillText: function searchBillText(e) {
    e.preventDefault();
    e.stopPropagation();
    var search_params = document.getElementById("bill-text-search-input").value;
    Navigator.vent.trigger("bill:home:search", search_params);
  },
  billByNumber: function billByNumber(e) {
    e.preventDefault();
    e.stopPropagation();
    var doctype = document.getElementById("doctype").value;
    var number = document.getElementById("bill-number-search-input").value;
    Navigator.vent.trigger("bill:detail:show", doctype + '/' + number);
    // for analytics
    const filter = {
      filter_type: "bill_search",
      value: `${doctype}/${number}`
    };
    Navigator.vent.trigger("bills:search:applied", filter);
  }
});